import React from "react";
import HeroContainer from "./HeroContainer";

export default function Hero() {
  return (
    <div className=" bg-gradient-to-br from-darkBlue to-blue-600  bg-center bg-no-repeat bg-cover h-full md:h-screen w-screen ">
      <HeroContainer />
    </div>
  );
}
